import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a10cdf3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "assess-view-toggle",
  class: "tw-flex tw-flex-wrap"
}
const _hoisted_2 = { class: "tw-flex tw-flex-wrap md:tw-items-center md:tw-justify-end tw-gap-y-[15px]" }
const _hoisted_3 = { class: "tw-flex tw-gap-[15px]" }
const _hoisted_4 = { class: "toggle-switch-view tw-p-1" }
const _hoisted_5 = ["value", "onClick"]
const _hoisted_6 = ["id", "data-cy"]
const _hoisted_7 = { class: "tw-px-[5px] tw-py-[3px] tw-bg-[#E4F1FF] tw-text-[#211F58] tw-rounded-[4px] tw-text-[11px] tw-font-medium tw-font-[Poppins]" }

import { checkIsHavePermisstion, getComponentUiText } from "@/utils/utilities";
import { computed, h, onMounted, onUpdated, Ref, ref, watch } from "vue";
import GridIcon from "@/components/svgs/gridIcon.vue";
import ViewIcon from "@/components/svgs/viewIcon.vue";
import ButtonBulkActions from "@/components/common/setting/buttonBulkActions.vue";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";
import store from "@/store";
import { useRoute } from "vue-router";
import {
  ASSESSMENT_ANSWER_STORE_TYPE,
  assessmentViews,
  checklistStatusId,
  localStorageKey,
  mainAssessmentFilterDefaul,
  MODAL_NAME,
  successStatusCodes,
} from "@/utils/constants";
import {
  IFilterSelect,
  IFilterTarget,
  IModalMessage,
} from "@/interfaces/common/common";
import AssessmentBulkAnswerQuestions from "@/components/assessments/assessmentBulkAnswerQuestions.vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IAssessmentChecklistItem } from "@/interfaces/assessments/IAssessmentDetails";
import { postAnswerQuestion } from "@/services/assessment";
import { showErrorAPI } from "@/services/apiRoutes";
import { Assessment, Checklist } from "@/services/apiRoutes/routes";
import { postToggleChecklistItems } from "@/services/assessment";
import { ComputedRef } from "vue";
import { groupFilters } from "@/services/vendor";
import cloneDeep from "lodash/cloneDeep";

const OFFSET_POPOVER = 20;


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentViewToggle',
  props: {
  selectedQuestions: {
    type: Array as () => number[],
    default: () => [],
  },
  listQuestionsSelected: {
    type: Array as () => IAssessmentChecklistItem[],
    default: () => [],
  },
  listQuestionsActive: {
    type: Array as () => IAssessmentChecklistItem[],
    default: () => [],
  },
  options: {
    type: Array as () => any[],
    default: () => [
      {
        value: assessmentViews.default,
        text: getComponentUiText(
          "app-component-assessment-view-toggle-button-1",
        ),
        icon: GridIcon,
        textHover: getComponentUiText(
          "app-component-assessment-default-view-text-hover-button-1",
        ),
      },
      {
        value: assessmentViews.list,
        text: getComponentUiText(
          "app-component-assessment-view-toggle-button-2",
        ),
        icon: ViewIcon,
        textHover: getComponentUiText(
          "app-component-assessment-advanced-view-text-hover-button-1",
        ),
      },
    ],
    required: false,
  },
  targetFilter: {
    type: Array as () => IFilterTarget[],
    default: () => [],
  },
},
  emits: [
  "update:view",
  "update:isMasterItems",
  "update:selectedQuestionsAfterSelected",
  "update:loading",
  "update:filter",
],
  setup(__props, { emit }) {

const props = __props;




const checklistIdParam = ref<number>(0);
const route = useRoute();
const isHaveExcluded: Ref<boolean> = ref(false);
const isHavePermisstionShowMaster: any = ref(false);
const view: Ref<string> = computed(
  () => store.getters["Assessment/getAssessmentView"],
);

const isChecklistCompleted: ComputedRef<boolean> = computed(() => {
  const statusId =
    store.getters["Assessment/getChecklistInforDetail"].checklistStatusId;

  return (
    statusId === checklistStatusId.completed ||
    statusId === checklistStatusId.paused ||
    statusId === checklistStatusId.defunct
  );
});

onMounted(async () => {
  // set default filter value if not exist
  const filterValue = localStorage.getItem(
    localStorageKey.mainAssessmentFilter,
  );
  checklistIdParam.value = Number(route.query.checklistId);
  isHavePermisstionShowMaster.value = await checkIsHavePermisstion(
    "assess_input__show_master_items",
  );
});

const hasMasterItem = computed(() => {
  return (
    props.listQuestionsSelected.filter((item) => item.isMaster).length >= 1
  );
});

const hasActiveItem = computed(() => {
  return (
    props.listQuestionsSelected.filter((item) => !item.isMaster).length >= 1
  );
});

onUpdated(() => {
  isHaveExcluded.value = props.listQuestionsSelected.some(
    (item) => item.checklistItemIsExcluded,
  );
});
const viewBy = (value: string) => {
  emit("update:view", value);
  store.dispatch("Assessment/updateAssessmentView", value);
};

const handleUpdateItems = async (
  checklistItems: Partial<IAssessmentChecklistItem>[],
) => {
  try {
    const params = {
      checklistId: checklistIdParam.value,
      checklistItems,
    };
    const checklistItemsUpdate = checklistItems.map((item) => ({
      checklistItemComplianceTypeValue: null,
      ...item,
    }));
    const paramsUpdate = {
      checklistId: checklistIdParam.value,
      checklistItems: checklistItemsUpdate,
    };
    const result = await postAnswerQuestion(params);
    if (result.status === successStatusCodes.OK) {
      emit("update:selectedQuestionsAfterSelected", []);
    }
    await store.dispatch("Assessment/updateListCheckListItems", paramsUpdate);
  } catch (error) {
    showErrorAPI(error, Assessment.postAnswerQuestion);
  }
};

const showModalEditQuestion = () => {
  const dataUpdate = {} as Partial<IAssessmentChecklistItem>;
  const listItems = props.listQuestionsSelected.filter(
    (item) => !item.checklistItemIsExcluded && !item.isMaster,
  );

  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-assessment-modal-bulk-edit-question-header-1",
      ),
      description: getComponentUiText(
        "app-assessment-modal-bulk-answer-question-description-1",
      ),
      list: listItems.map(
        (item) =>
          `${item.checklistItemName}${
            item.subName ? ` | ${item.subName}` : ""
          }`,
      ),
      buttonText: getComponentUiText(
        "app-assessment-modal-bulk-answer-question-button-text-1",
      ),
      buttonRed: false,
      slotCustom: h(AssessmentBulkAnswerQuestions, {
        handleUpdateData: (data: Partial<IAssessmentChecklistItem>) => {
          Object.assign(dataUpdate, data);
        },
      }),
      updateDataFunction: async () => {
        const checklistItems = listItems.map((item) => ({
          checklistItemId: item.checklistItemId,
          ...dataUpdate,
        }));
        await handleUpdateItems(checklistItems);
      },
    },
    events: {
      "update:data": () => {
        const checklistItems = listItems.map((item) => ({
          checklistItemId: item.checklistItemId,
          ...dataUpdate,
        }));
        handleUpdateItems(checklistItems);
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const showModalSetCompliant = () => {
  const listItems = props.listQuestionsSelected.filter(
    (item) => !item.checklistItemIsExcluded && !item.isMaster,
  );

  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-assessment-modal-set-to-compliant-header-1",
      ),
      description: getComponentUiText(
        "app-assessment-modal-set-to-compliant-description-1",
      ),
      list: listItems.map(
        (item) =>
          `${item.checklistItemName}${
            item.subName ? ` | ${item.subName}` : ""
          }`,
      ),
      buttonText: getComponentUiText(
        "app-assessment-modal-bulk-answer-question-button-text-1",
      ),
      buttonRed: false,
      updateDataFunction: async () => {
        const checklistItems = listItems.map((item) => ({
          checklistItemId: item.checklistItemId,
          checklistItemComplianceOverride: 1,
        }));
        await handleUpdateItems(checklistItems);
      },
    },
    events: {
      "update:data": () => {
        const checklistItems = listItems.map((item) => ({
          checklistItemId: item.checklistItemId,
          checklistItemComplianceOverride: 1,
        }));
        handleUpdateItems(checklistItems);
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const showModalSetNonCompliant = () => {
  const listItems = props.listQuestionsSelected.filter(
    (item) => !item.checklistItemIsExcluded && !item.isMaster,
  );

  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-assessment-modal-set-to-non-compliant-header-1",
      ),
      description: getComponentUiText(
        "app-assessment-modal-set-to-non-compliant-description-1",
      ),
      list: listItems.map(
        (item) =>
          `${item.checklistItemName}${
            item.subName ? ` | ${item.subName}` : ""
          }`,
      ),
      buttonText: getComponentUiText(
        "app-assessment-modal-bulk-answer-question-button-text-1",
      ),
      buttonRed: false,
      updateDataFunction: async () => {
        const checklistItems = listItems.map((item) => ({
          checklistItemId: item.checklistItemId,
          checklistItemComplianceOverride: 0,
        }));
        await handleUpdateItems(checklistItems);
      },
    },
    events: {
      "update:data": () => {
        const checklistItems = listItems.map((item) => ({
          checklistItemId: item.checklistItemId,
          checklistItemComplianceOverride: 0,
        }));
        handleUpdateItems(checklistItems);
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const showModalResetAnswers = () => {
  const listItems = props.listQuestionsSelected.filter(
    (item) => !item.checklistItemIsExcluded && !item.isMaster,
  );

  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText("app-assessment-modal-reset-answers-header-1"),
      description: getComponentUiText(
        "app-assessment-modal-reset-answers-description-1",
      ),
      list: listItems.map(
        (item) =>
          `${item.checklistItemName}${
            item.subName ? ` | ${item.subName}` : ""
          }`,
      ),
      buttonText: getComponentUiText(
        "app-assessment-modal-reset-answers-button-text-1",
      ),
      buttonRed: true,
      updateDataFunction: async () => {
        const checklistItems = listItems.map((item) => ({
          checklistItemId: item.checklistItemId,
          checklistItemComplianceTypeValueId: null,
          checklistItemComplianceOverride: null,
          checklistItemCompensatingControlValue: null,
          checklistItemCompensatingControlDescription: null,
        }));

        await handleUpdateItems(checklistItems);
        handleFetchScoreUpdateChecklist();
      },
    },
    events: {
      "update:data": async () => {
        const checklistItems = listItems.map((item) => ({
          checklistItemId: item.checklistItemId,
          checklistItemComplianceTypeValueId: null,
          checklistItemComplianceOverride: null,
          checklistItemCompensatingControlValue: null,
          checklistItemCompensatingControlDescription: null,
        }));

        await handleUpdateItems(checklistItems);
        handleFetchScoreUpdateChecklist();
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const handleFetchScoreUpdateChecklist = () => {
  store.dispatch(
    "Assessment/fetchCheckListIdMetricsCompletion",
    checklistIdParam.value,
  );

  store.dispatch(
    "Assessment/getChecklistMetricScoreCompletion",
    checklistIdParam.value,
  );

  store.dispatch("Assessment/fetchCategories", {
    checklistId: checklistIdParam.value,
    reload: false,
  });
};

const showEnabLeAndDisableBulkAnswersQuestionModal = (isEnable = false) => {
  const title = isEnable
    ? getComponentUiText(
        "app-component-assessments-question-bulk-action-item-enable-1",
      )
    : getComponentUiText(
        "app-component-assessments-question-bulk-action-exclude-question-1",
      );
  const buttonText = isEnable
    ? getComponentUiText(
        "app-assessment-modal-bulk-answer-question-enabled-all-button-text-1",
      )
    : getComponentUiText(
        "app-assessment-modal-bulk-answer-question-exclude-all-button-text-1",
      );
  const description = isEnable
    ? getComponentUiText(
        "app-assessment-modal-bulk-answer-question-enable-all-description-1",
      )
    : getComponentUiText(
        "app-assessment-modal-bulk-answer-question-exclude-all-description-1",
      );
  const alrealdyText = isEnable
    ? getComponentUiText(
        "app-assessment-modal-bulk-answer-question-enable-all-button-title-1",
      )
    : getComponentUiText(
        "app-assessment-modal-bulk-answer-question-exclude-all-button-title-1",
      );
  const list = props.listQuestionsSelected
    .filter((item) => !item.isMaster)
    .map((item) => {
      let checklistItemName = `${item.checklistItemName}${
        item.subName ? ` | ${item.subName}` : ""
      }`;
      if (
        (item.checklistItemIsExcluded && !isEnable) ||
        (!item.checklistItemIsExcluded && isEnable)
      ) {
        checklistItemName = `${item.checklistItemName}${
          item.subName ? ` | ${item.subName}` : ""
        } (${alrealdyText})`;
      }
      return checklistItemName;
    });
  const checklistItemIds = props.listQuestionsSelected
    .filter(
      (item) =>
        item.checklistItemId &&
        ((item.checklistItemIsExcluded && isEnable) ||
          (!item.checklistItemIsExcluded && !isEnable)) &&
        !item.isMaster,
    )
    .map((item) => item.checklistItemId);
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title,
      description,
      list,
      buttonText,
      buttonRed: true,
      disableButtonRed: checklistItemIds.length === 0,
      hiddenHelp: false,
      updateDataFunction: async () => {
        try {
          const result = await postToggleChecklistItems(
            checklistIdParam.value,
            checklistItemIds,
          );
          if (result.status === successStatusCodes.OK) {
            emit("update:selectedQuestionsAfterSelected", []);
          }

          await store.dispatch("Assessment/updateCheckListItems", {
            checklistId: checklistIdParam.value,
            checklistItemIds,
            type: ASSESSMENT_ANSWER_STORE_TYPE.EXCLUDE_ITEM,
          });
          props.listQuestionsSelected.forEach((item) => {
            item.checklistItemIsExcluded = !isEnable;
          });
        } catch (error) {
          showErrorAPI(error, Checklist.toggleChecklistToItem);
        }
      },
    },
    events: {
      "update:data": async () => {
        try {
          const result = await postToggleChecklistItems(
            checklistIdParam.value,
            checklistItemIds,
          );
          if (result.status === successStatusCodes.OK) {
            emit("update:selectedQuestionsAfterSelected", []);
          }

          await store.dispatch("Assessment/updateCheckListItems", {
            checklistId: checklistIdParam.value,
            checklistItemIds,
            type: ASSESSMENT_ANSWER_STORE_TYPE.EXCLUDE_ITEM,
          });
          props.listQuestionsSelected.forEach((item) => {
            item.checklistItemIsExcluded = !isEnable;
          });
        } catch (error) {
          showErrorAPI(error, Checklist.toggleChecklistToItem);
        }
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const showBulkAddMasterItemsModal = () => {
  if (isChecklistCompleted.value) {
    return;
  }
  const listItems = props.listQuestionsSelected.filter((item) => item.isMaster);

  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-assessment-modal-add-master-item-header-1",
      ),
      description: getComponentUiText(
        "app-assessment-modal-add-master-item-description-1",
      ),
      list: listItems.map(
        (item) =>
          `${item.checklistItemName}${
            item.subName ? ` | ${item.subName}` : ""
          }`,
      ),
      buttonText: getComponentUiText(
        "app-assessment-modal-bulk-answer-question-button-text-2",
      ),
      buttonRed: false,
      updateDataFunction: async () => {
        await handleAddMasterItems(
          listItems.map((item) => item.checklistItemId),
        );
      },
    },
    events: {
      "update:data": () =>
        handleAddMasterItems(listItems.map((item) => item.checklistItemId)),
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const handleAddMasterItems = async (
  masterItemIds: Array<IAssessmentChecklistItem["checklistItemId"]>,
) => {
  try {
    const activeCategoryId = store.getters["Assessment/getActiveCategory"];
    await store.dispatch("Assessment/updateMasterItems", {
      checklistId: checklistIdParam.value,
      masterItemIds,
      activeCategoryId,
    });
    emit("update:selectedQuestionsAfterSelected", []);
    reloadData();
  } catch (error) {
    showErrorAPI(error, Checklist.addItemFromMaster);
  }
};

const reloadData = async () => {
  emit("update:loading", true);
  const params = {
    checklistIdParam: checklistIdParam.value,
    showMasterItem: true,
  };
  await store.dispatch("Assessment/fetchChecklistByCategory", params);
  emit("update:loading", false);
};
const isShowMoreActions = ref(false);
const handleShowBulkAction = () => {
  isShowMoreActions.value = !isShowMoreActions.value;
  if (!hasActiveItem.value && !hasMasterItem.value) {
    isShowMoreActions.value = false;
  }
};

const showModalDuplicateQuestion = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_DUPLICATE_QUESTION,
    properties: {
      data: props.listQuestionsSelected,
      checklistId: Number(route.query.checklistId),
    },
    events: {
      "update:success": () => emit("update:selectedQuestionsAfterSelected", []),
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};
watch(
  () => props.selectedQuestions,
  (value) => {
    if (value.length < 1) {
      isShowMoreActions.value = false;
    }
  },
);

return (_ctx: any,_cache: any) => {
  const _component_b_popover = _resolveComponent("b-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { onClick: handleShowBulkAction }, [
        _createVNode(ButtonBulkActions, {
          active: hasMasterItem.value || hasActiveItem.value,
          "show-more-actions": isShowMoreActions.value,
          "id-popover": 'popover-assessment-view-toggle',
          "show-acction-click": true,
          "selected-number": __props.listQuestionsSelected.length,
          "onUpdate:showMoreActions": _cache[2] || (_cache[2] = (value) => (isShowMoreActions.value = value))
        }, {
          default: _withCtx(() => [
            (hasMasterItem.value)
              ? (_openBlock(), _createBlock(CustomDropDownItem, {
                  key: 0,
                  style: 'normal',
                  "id-text": 'app-component-assessments-question-bulk-action-item-add-1',
                  onClick: showBulkAddMasterItemsModal
                }))
              : _createCommentVNode("", true),
            (hasActiveItem.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (!isHaveExcluded.value)
                    ? (_openBlock(), _createBlock(CustomDropDownItem, {
                        key: 0,
                        style: 'normal',
                        "id-text": 'app-component-assessments-question-bulk-action-item-edit-1',
                        onClick: showModalEditQuestion
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(CustomDropDownItem, {
                    style: 'normal',
                    "id-text": 'app-component-assessments-question-bulk-action-item-set-to-compliant-1',
                    onClick: showModalSetCompliant
                  }),
                  _createVNode(CustomDropDownItem, {
                    style: 'normal',
                    "id-text": 'app-component-assessments-question-bulk-action-item-set-to-non-compliant-1',
                    onClick: showModalSetNonCompliant
                  }),
                  _createVNode(CustomDropDownItem, {
                    style: 'normal',
                    "id-text": 'app-component-assessments-question-bulk-action-item-reset-answers-1',
                    onClick: showModalResetAnswers
                  }),
                  _createVNode(CustomDropDownItem, {
                    style: 'normal',
                    "id-text": 'app-component-assessments-question-bulk-action-item-enable-1',
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showEnabLeAndDisableBulkAnswersQuestionModal(true)))
                  }),
                  _createVNode(CustomDropDownItem, {
                    style: 'normal',
                    "id-text": 'app-component-assessments-question-bulk-action-exclude-question-1',
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showEnabLeAndDisableBulkAnswersQuestionModal(false)))
                  }),
                  _createVNode(CustomDropDownItem, {
                    style: 'normal',
                    "id-text": 'app-component-assess-input-popover-duplicate-questions-1',
                    "is-last-item": true,
                    onClick: showModalDuplicateQuestion
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["active", "show-more-actions", "selected-number"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item, index) => {
        return (_openBlock(), _createElementBlock("label", { key: index }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((view).value = $event)),
            type: "radio",
            value: item.value,
            onClick: ($event: any) => (viewBy(item.value))
          }, null, 8, _hoisted_5), [
            [_vModelRadio, view.value]
          ]),
          _createElementVNode("span", {
            id: `${item.value}`,
            "data-cy": `assessment-view-toggle-button-${index + 1}`,
            class: "label tw-font-[Poppins] tw-text-[10px] tw-font-[600] tw-leading-[100%] tw-uppercase"
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))
          ], 8, _hoisted_6),
          _createVNode(_component_b_popover, {
            target: `${item.value}`,
            triggers: "hover",
            placement: "top-start",
            "custom-class": "custom-actions-popover-hover",
            offset: 8,
            delay: {
            show: 0,
            hide: 100,
          },
            onShow: ($event: any) => (true)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.textHover), 1)
            ]),
            _: 2
          }, 1032, ["target"])
        ]))
      }), 128))
    ])
  ]))
}
}

})